'use client';

import { c as _c } from "react/compiler-runtime";
import { FC, PropsWithChildren, useMemo } from 'react';
import { cacheExchange, createClient, fetchExchange, ssrExchange, UrqlProvider } from '@urql/next';
import { fetchOptions } from '@ordering/urql/client';
export const UrqlProviderWrapper: FC<PropsWithChildren> = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ssrExchange({
      isClient: typeof window !== "undefined"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const ssr = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    const client = createClient({
      url: process.env.NEXT_PUBLIC_APPSYNC_URL,
      exchanges: [cacheExchange, fetchExchange],
      fetchOptions
    });
    t2 = [client, ssr];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [client_0, ssr_0] = t2;
  let t3;
  if ($[2] !== children) {
    t3 = <UrqlProvider client={client_0} ssr={ssr_0}>{children}</UrqlProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default UrqlProviderWrapper;